
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AppIcon',
  props: {
    name: String,
    type: String,
    color: String,
    outlined: Boolean
  },
  setup() {
    return { }
  }
})
